import { render, staticRenderFns } from "./SponsoringAvailableLabel.vue?vue&type=template&id=1e2603cc&"
import script from "./SponsoringAvailableLabel.vue?vue&type=script&lang=js&"
export * from "./SponsoringAvailableLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports